import { useDataProvider, useNotify, useRefresh } from "ra-core"
import React from "react"
import { Box, Button, Modal, Typography } from "@mui/material"
import RoundedPanel from "common/RoundedPanel"
import "styles.scss"
import { ModalProps } from "./common"

export const DeleteUserModal = ({ record, open, onClose }: ModalProps) => {
  const dataProvider = useDataProvider()
  const refresh = useRefresh()
  const notify = useNotify()

  const handleDelete = async () => {
    try {
      await dataProvider.delete("users", { id: record.id })
      refresh()
      onClose()
      notify("User deleted successfully", { type: "success" })
    } catch (error) {
      notify("Failed to delete user", { type: "warning" })
    }
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <RoundedPanel modal>
        <Typography variant="h5" component="h1" gutterBottom>
          You are about to delete <strong>{record.userName}</strong> account. Once you confirm it below, the following
          will take place:
        </Typography>
        <Box height={16} />
        <Typography variant="body1" component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            User will be marked as non-active, out of office, account not confirmed
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            User will be removed from GCs and company
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            Login, name, last name and email will be changed to: DELETED#USER#UUID
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            LinkedIn URL will be deleted
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            Roles will be removed
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            {'All skills will be set to "deleted"'}
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            Community Manager will be removed
          </Typography>
          <Typography component="li" variant="body1" sx={{ mb: 1 }}>
            {
              'If user worked as a "single-person company", i.e. s/he is the admin and only member of that company, then:'
            }
            <Typography component="ul" variant="body1" sx={{ pl: 2, mt: 1 }}>
              <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                company billing information will be removed
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                company contact person will be removed
              </Typography>
              <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                if company name contained personal info, it will be changed to DELETED#COMPANY#UUID
              </Typography>
            </Typography>
          </Typography>
        </Typography>
        <Box height={32} />
        <Box display="flex" gap={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete User
          </Button>
        </Box>
      </RoundedPanel>
    </Modal>
  )
}
